<template>
	<b-form @submit.stop.prevent="save($event)">
		<div class="text-center" v-if="loading>0">
			<b-icon icon="circle-fill" animation="throb" font-scale="4"></b-icon>
		</div>
		<div v-else>
			<b-form-row>
				<b-col xl="4" lg="6" md="12" v-for="(t, idx) in settings.thresholds" :key="idx">
					<b-card class="mb-3">
						<h4 class="card-title">{{idx==0?'Lower threshold':`Gift Threshold ${idx}`}}</h4>
						<b-form-checkbox switch v-model="t.enable" class="mb-3">Enable this threshold</b-form-checkbox>
						<fieldset :disabled="!t.enable">
							<b-form-group label="Minimum amount">
								<b-input-group :append="`${user?.currency_code||'USD'} or more`">
									<b-input type="number" :readonly="idx <= 0" v-model="t.amount" :min="idx > 0 && 1 + parseFloat(settings.thresholds[idx-1].amount) || 0"></b-input>
								</b-input-group>
							</b-form-group>
							<b-form-group label="Time limit">
								<b-input-group append="minutes">
									<b-input v-model="t.timeLimit"></b-input>
								</b-input-group>
							</b-form-group>
							<b-form-checkbox switch v-model="t.reject">Reject songs over time limit</b-form-checkbox>
							<p class="text-muted">Otherwise limit playback time to the time limit set above</p>
							<b-form-group label="Minimum like-to-dislike ratio" class="mb-3">
								<b-input-group append="%">
									<b-input v-model.number="t.minRatio" type="number" min="0" max="100"></b-input>
								</b-input-group>
							</b-form-group>
							<b-form-group label="Minimum number of views" class="mb-0">
								<b-input v-model.number="t.minViews" type="number" min="0"></b-input>
							</b-form-group>
						</fieldset>
					</b-card>
				</b-col>
			</b-form-row>
			<p class="text-muted">
				Song requests from platforms such as PowerChat just use the rules from those platforms and ignore the rules above.
			</p>
			<p class="text-muted">
				For all the other platforms, rejection happens based on minimum like-to-dislike ratio, minimum number of views, and when the "Reject" switch is on, song duration. When the "Reject" switch is off, the song is added to the list but only plays up to the maximum duration.
			</p>
			<p class="text-muted">
				You can use timestamped links and that will be the starting point.
			</p>
			<b-card class="text-center mb-3">
				<b-alert variant="danger" :show="!!error">{{error}}</b-alert>
				<b-overlay :show="saving > 0" variant="dark" class="d-inline-block">
					<b-button variant="primary" type="submit">Save settings</b-button>
				</b-overlay>
			</b-card>
		</div>
	</b-form>
</template>

<script>
export default {
	name: 'SongSettings',
	data() { return {
		settings: {},
		user: null,
		error: null,
		loading: 0,
		saveError: null,
		saving: 0,
		googleFonts: [],
		curColor: {},
		copyingStyle: false,
	}},
	async mounted() {
		try {
			this.loading++;
			this.error = null;
			let settings = await this.$api.get('widgetSettings/song');
			settings ||= {};
			settings.thresholds ||= [];
			settings.thresholds.length = 3;
			settings.thresholds[0] ||= {
				enable: false,
				amount: 0,
				timeLimit: 5,
				reject: true,
				minRatio: 0,
				minViews: 0,
			};
			settings.thresholds[1] ||= {
				enable: true,
				amount: 3,
				timeLimit: 1,
				reject: false,
				minRatio: 0,
				minViews: 0,
			};
			settings.thresholds[2] ||= {
				enable: false,
				amount: 5,
				timeLimit: 2,
				reject: false,
				minRatio: 0,
				minViews: 0,
			};
			this.settings = settings;
			this.user = await this.$api.get('userData');
		} catch(e) {
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	methods: {
		async save() {
			try {
				this.saving++;
				this.saveError = null;

				await this.$api.post('widgetSettings/song', {
					...this.settings,
				});
			} catch(e) {
				console.error(e);
				this.saveError = e;
			} finally {
				this.saving--;
			}
		},
	},
};
</script>
